export default [
    {
        icon: 'GridIcon',
        route: 'intra-op',
        title: 'IntraOp'
    },
]
